import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface SignInPayload {
  email: string;
  password: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl = `${environment.apiBaseUrl}/auth/admin/login`;

  constructor(private http: HttpClient) {}

  signIn(payload: SignInPayload): Observable<any> {
    return this.http.post(this.apiUrl, payload);
  }
}